import './CheckBoxItem.css';

import { IonCheckbox, IonIcon, IonItem, IonText } from '@ionic/react';
import { alertCircleOutline } from 'ionicons/icons';

interface Props {
    provider?: any,
    name?: string,
    key: string,
    label: string,
    disabled?: boolean,
    change?: any,
    click?: any
}

const CheckBoxItem: React.FC<Props> = (props) => {
    return <div className="checkbox">
        <IonItem lines="none">
            <IonText>{props.label}</IonText>
            <IonCheckbox name={props.name} slot="start" disabled={props.disabled} checked={props.provider?.form[props.name!].value} onClick={props.click!} onIonChange={(e) => { props.provider?.setValue(e); props.change?.(e) }} />
        </IonItem>

        {props.provider?.form[props.name!].error && props.provider?.form[props.name!].error!.length > 0 ? <div className="error"><div><IonIcon src={alertCircleOutline} /> <IonText>{props.provider?.form[props.name!].error}</IonText></div></div> : null}
    </div>
}

export default CheckBoxItem